module.exports = __webpack_public_path__ + "img/classic@2x.b42c85c.jpg";